import { GiveawayStepLabels, GoodieGiveawayStepLabels } from 'swag-common/constants/giveaway.constants';
import { GiveawayTypes } from 'swag-common/interfaces';
const possibleSwagGiveawaySteps = Object.keys(GiveawayStepLabels);
const possibleGoodieGiveawaySteps = Object.keys(GoodieGiveawayStepLabels);
export const getGiveawayStepsByType = giveawayType => {
  if (giveawayType === GiveawayTypes.goodie) {
    return possibleGoodieGiveawaySteps;
  }
  return possibleSwagGiveawaySteps;
};